type ModalInnerPropsType = {
  children: React.ReactNode;
};

const ModalInner = ({ children }: ModalInnerPropsType): React.ReactElement => {
  return <div className="w-full p-[16px] mobile:p-[40px]">{children}</div>;
};

export default ModalInner;
